// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Zx-z","tooltipWrapper":"_x-z","icon":"ay-z","tooltip":"by-z","content":"cy-z"};